import get from "lodash.get";

export const pickSeparate = (obj, arr, symbol) =>
  arr
    .map((item) => get(obj, item))
    .filter(Boolean)
    .join(symbol);
